module.exports = __webpack_public_path__ + "static/media/appleLogo.384d8f22.svg";